import { atomWithStorage } from 'jotai/utils';
import { TUser } from '@Eikochain/types';

export const userAtom = atomWithStorage<TUser | null>("user", null);
